import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FournisseurSearch from './FournisseurSearch';
import { fetchSuggestionsFournisseur, clearSuggestionsFournisseur, setFournisseurValue } from 'store/fournisseur/fournisseurActions';

class FournisseurSearchContainer extends React.Component {
    handleSearchFournisseurs = (searchValue) => {
        this.props.fetchSuggestionsFournisseur(searchValue);
    }

    handleClearFournisseurs = () => {
        this.props.clearSuggestionsFournisseur();
    }

    handleChange = (value) => {
        const { selectedId } = this.props;
        this.props.setFournisseurValue(value, selectedId);
    }

    handleSuggestionSelected = (id, value, code, nom) => {
        this.props.setFournisseurValue(value, id);
        this.props.onChange(id, code, nom);
    }

    render() {
        const { fournisseurs, value, selectedId, isRequired, error } = this.props;

        return (
            <FournisseurSearch
                fournisseurs={fournisseurs}
                onSearch={this.handleSearchFournisseurs}
                onChange={this.handleChange}
                onClear={this.handleClearFournisseurs}
                error={error}
                isRequired={isRequired}
                onSuggestionSelected={this.handleSuggestionSelected}
                value={value}
                selectedId={selectedId}
            />);
    }
}

const mapStateToProps = (state, ownProps) => ({
    fournisseurs: state.fournisseur[ownProps.namespace].suggestions.items,
    value: state.fournisseur[ownProps.namespace].suggestions.value,
    selectedId: state.fournisseur[ownProps.namespace].suggestions.selectedId
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchSuggestionsFournisseur: (searchValue) => dispatch(fetchSuggestionsFournisseur(ownProps.namespace, searchValue)),
    clearSuggestionsFournisseur: () => dispatch(clearSuggestionsFournisseur(ownProps.namespace)),
    setFournisseurValue: (value, selectedId) => dispatch(setFournisseurValue(ownProps.namespace, value, selectedId))
});

FournisseurSearch.propTypes = {
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(FournisseurSearchContainer);